var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradableIconPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8283 2.47083L7.12739 2.47083C6.55048 2.47083 5.9972 2.7 5.58926 3.10794C5.18132 3.51587 4.95215 4.06915 4.95215 4.64606L4.95215 22.048C4.95215 22.6249 5.18132 23.1781 5.58926 23.5861C5.9972 23.994 6.55048 24.2232 7.12739 24.2232L20.1788 24.2232C20.7557 24.2232 21.309 23.994 21.7169 23.5861C22.1249 23.1781 22.354 22.6249 22.354 22.048L22.354 8.99654L15.8283 2.47083Z",
    stroke: "#3A3A3A",
    strokeWidth: 1.48151,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43262 9.43164L12.8375 9.43164",
    stroke: "#3A3A3A",
    strokeWidth: 1.30514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43262 12.0419L11.0429 12.0419L13.6532 12.0419",
    stroke: "#3A3A3A",
    strokeWidth: 1.30514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43262 14.6522L11.0429 14.6522L12.348 14.6522",
    stroke: "#3A3A3A",
    strokeWidth: 1.30514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8291 2.47083L15.8291 8.99654L22.3548 8.99654",
    stroke: "#3A3A3A",
    strokeWidth: 1.30515,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1452_5228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5688 18.5677C19.2507 18.5677 20.6141 17.2043 20.6141 15.5224C20.6141 13.8405 19.2507 12.477 17.5688 12.477C15.8869 12.477 14.5234 13.8405 14.5234 15.5224C14.5234 17.2043 15.8869 18.5677 17.5688 18.5677Z",
    stroke: "#3A3A3A",
    strokeWidth: 1.30514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.92 18.0848L15.3936 22.0481L17.5688 20.7429L19.744 22.0481L19.2176 18.0804",
    stroke: "#3A3A3A",
    strokeWidth: 1.30514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1452_5228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.83085,
    height: 13.0514,
    fill: "white",
    transform: "translate(13.6533 10.7368)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradableIconPlayer);
export default __webpack_public_path__ + "static/media/gradableIconPlayer.eb367b7101b16b777ea356f482df2a58.svg";
export { ForwardRef as ReactComponent };